// Light haptic tap for touch devices that support it (no-op elsewhere).
export const tapFeedback = () => {
  if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
    navigator.vibrate(12);
  }
};
